import React, { useState } from 'react';
// @ts-ignore
import styles from './PatientsFilledQuestionnairesListItem.module.scss';
import { Theme } from '../../../../Enums/Theme.enum';
import useTranslation from '../../../../Hooks/useTranslation';
import QuestionnaireResultsModal from '../QuestionnaireResults/QuestionnaireResultsModal';
import moment from 'moment';
import { useAppContext } from '../../../../Services/AppContext';
import LinkButton from '../../../../Components/Button/LinkButton';
import FirstUpper from '../../../../Components/FirstUpper';
interface PatientsFilledQuestionnairesListItemProps {
	id: string;
	createdAt: string;
	patientName?: string;
	patientId: string;
	doctor: string;
	questionnaire: string;
	questionnaireId: string;
	questionnaireCode: string;
	roundValuesTo?: number;
}

const PatientsFilledQuestionnairesListItem: React.FC<
	PatientsFilledQuestionnairesListItemProps
> = ({
	id,
	createdAt,
	patientId,
	patientName,
	doctor,
	questionnaire,
	questionnaireCode,
	questionnaireId,
	roundValuesTo,
}) => {
	const { t } = useTranslation();
	const { dateFormatMoment } = useAppContext();
	const [isResultOpen, setIsResultOpen] = useState(false);

	const handleOpenResult = async () => {
		setIsResultOpen(true);
	};

	const handleCloseResult = () => {
		setIsResultOpen(false);
	};

	return (
		<>
			<div className={styles.item}>
				<div className={styles.content}>
					<div>
						<div className={styles.title}>{questionnaire}</div>
					</div>
					<div className={styles.extra}>
						<div className={styles.name}>
							<span>{t('base.filled')}: </span>
							{moment(createdAt).format(dateFormatMoment + ' HH:mm')}
						</div>
						<div className={styles.name}>
							<span>
								<FirstUpper>{t('base.sentBy')}</FirstUpper>:{' '}
							</span>
							{doctor}
						</div>
					</div>
				</div>
				<div className={styles.controls}>
					<LinkButton
						title='base.result'
						theme={Theme.BLUE}
						onClick={handleOpenResult}
						firstUpper
					/>
				</div>
			</div>
			<QuestionnaireResultsModal
				questionnaireCode={questionnaireCode}
				questionnaireName={questionnaire}
				roundValuesTo={roundValuesTo}
				patientId={patientId}
				isOpen={isResultOpen}
				onClose={handleCloseResult}
			/>
		</>
	);
};

export default PatientsFilledQuestionnairesListItem;
